// create a maintenance page for 404 error

import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";


export default function Maintenance() {
    const navigate = useNavigate();

return (
    <>
    <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        textAlign="center"
        bgcolor="#1e1e1e"
        color={"whitesmoke"}
    >
        <Typography variant="h3" gutterBottom>
            404 - Page Not Found
        </Typography>
        <Typography variant="body1" color="textSecondary" gutterBottom>
            Oops! The page you are looking for is currently under maintenance or does not exist.
        </Typography>
        <Button
            variant="outlined"
            sx={{ color: "whitesmoke", borderColor: "whitesmoke", marginTop: '1rem' }}
            onClick={() => {
                navigate("/");
            }}
        >
            Go Back to Home
        </Button>
    </Box>
    </>
)
}